import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function MachinesFight() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Machines Fight Back</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">AI-Powered Defense</div>
                                <h1 className="prod-hero-title">Fight Back Against <span>Cyberattacks</span></h1>
                                <p>Leveraging all the resources at your disposal is key to building a robust cyber defense strategy. Cloud Mind's next-gen response system continuously monitors your network and neutralizes threats before they impact your business.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg.png')} alt="Machines Fight Back" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image" style={{ borderRadius: 16, overflow: 'hidden', background: '#111', padding: 8 }}>
                                <iframe
                                    width="100%"
                                    height="340"
                                    src="https://www.youtube.com/embed/cB6cpJIHty4?si=JpmSlMvqcQyELjIl"
                                    title="Machine Fight Back"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                    style={{ borderRadius: 12, display: 'block' }}
                                ></iframe>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Next-Gen Defense</div>
                                <h2>Machine Fight Back</h2>
                                <p>You work hard to protect your business from the ever-changing landscape of cyber-attacks. And yet, no matter what you do, it never seems to be enough. That's where cybersecurity defense goes next-gen.</p>
                                <p>Cloud Mind has partnered with a futuristic and revolutionary response system that continuously monitors your network and alerts you to any new threats, before they have a chance to impact your business.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Key Insights */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Key Insights</div>
                        <h2 className="prod-section-title">AI-Powered <span>Cyber Resilience</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Stay ahead of attackers with autonomous, intelligent defense capabilities</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-random"></i></div>
                            <h4>You Can't Predict What's Next</h4>
                            <p>Risk is a fundamental and often ignored part of business. You can't predict what the next attack will look like — but you can anticipate trends. Our Cyber Resilience Platform helps inform and enable your team with actionable insight into cyber threats.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-brain"></i></div>
                            <h4>Advance Well-Being with AI</h4>
                            <p>AI-powered security platforms deliver the world's most effective defense methods — providing a safe, secure environment to proactively detect, analyze, and neutralize threats before they can cause harm.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-shield"></i></div>
                            <h4>Continuous Network Monitoring</h4>
                            <p>Revolutionary response systems that continuously monitor your network 24/7, alerting you to new threats in real time — before they have a chance to impact your business operations.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '80px 0' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Fight Back Against Cyberattacks?</h3>
                            <p>Deploy next-gen AI-powered defense with CLOUD MIND and neutralize threats before they reach your business.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
